import {
  alpha,
  Container,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import { grey } from "@mui/material/colors";

const PageHeader = ({ title, subtitle, completedItems, totalItems }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
          color: "white",
          borderRadius: 3,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background elements */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.1,
            background: `radial-gradient(circle at 20% 150%, ${theme.palette.primary.light} 0%, transparent 50%)`,
            zIndex: 0,
          }}
        />

        <Box
          component={motion.div}
          animate={{
            rotate: [0, 5],
            y: [0, -5, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            position: "absolute",
            width: 300,
            height: 300,
            borderRadius: "50%",
            background: alpha(theme.palette.primary.light, 0.2),
            filter: "blur(40px)",
            top: -150,
            right: -100,
            zIndex: 0,
          }}
        />

        <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <Box>
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  fontWeight={800}
                  sx={{ textTransform: "uppercase", color: grey["50"] }}
                >
                  {title}
                </Typography>
                <Typography variant="subtitle1" sx={{ mt: 1, opacity: 0.9 }}>
                  {subtitle}
                </Typography>

                {completedItems !== undefined && (
                  <Box sx={{ mt: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: "100%",
                          height: 8,
                          bgcolor: alpha("#fff", 0.2),
                          borderRadius: 4,
                          mr: 2,
                          overflow: "hidden",
                        }}
                      >
                        <motion.div
                          initial={{ width: 0 }}
                          animate={{
                            width: `${(completedItems / totalItems) * 100}%`,
                          }}
                          transition={{ duration: 1, delay: 0.5 }}
                          style={{
                            height: "100%",
                            backgroundColor: "#fff",
                            borderRadius: 4,
                          }}
                        />
                      </Box>
                      <Typography variant="body2" fontWeight="medium">
                        {Math.round((completedItems / totalItems) * 100)}%
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Paper>
    </motion.div>
  );
};

export default PageHeader;
